import React, { useMemo } from 'react';
import BrandsListDE from './BrandsListDE';
import BrandsListingUS from './BrandsListUS';
import { useAuthContext } from '@/contexts';

const BrandsListing = () => {
  const { profile } = useAuthContext();

  const Page = useMemo(() => {
    if (profile?.market === 'DE') {
      return BrandsListDE;
    }
    return BrandsListingUS;
  }, [profile?.market]);

  return <Page />;
};

export default BrandsListing;
